























import Vue from 'vue'
import { Component, Prop, Emit } from 'vue-property-decorator'
import SkillComponent from './SkillComponent.vue'
import Skill from '../models/Skill'
import { State, Getter, Action, Mutation } from '../store-helper'
import { IExam } from '../../../types'
import Question from '../models/Question'
import { qEditorState } from '../stores'

@Component({
  components: {
    SkillComponent
  }
})
export default class MetadataComponent extends Vue {
  private newSkillName: string = ''

  get exam() {
    return qEditorState.exam
  }

  get skills() {
    return qEditorState.skills
  }

  get question() {
    return qEditorState.question
  }

  constructor() {
    super()
  }

  public get explanation(): string {
    return this.question?.description || ''
  }

  public set explanation(value: string) {
    qEditorState.commitUpdateExplanation({ explanation: value })
  }

  public addNewSkill(value: string) {
    if (!this.newSkillName) return
    qEditorState.addSkill({ exam: this.exam, params: { name: this.newSkillName } })
    this.newSkillName = ''
  }
}
